import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { CONFIG, NAV, SERVICES, DISCLAIMER, telLink } from "../../data/content";
import { useLang } from "../../context/i18n";

export const Footer = () => {
  const { t } = useLang();
  const go = (id) => { const el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: "smooth" }); };
  return (
    <footer className="bg-[var(--navy)] text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-16 lg:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-white text-[var(--navy)] font-head text-lg font-extrabold">JS</div>
              <span className="font-head text-lg font-extrabold">Jan Seva Hospital</span>
            </div>
            <p className="mt-4 flex items-start gap-2 text-sm text-white/70">
              <MapPin size={18} className="mt-0.5 shrink-0" /> Dr. Kishori Mohan Complex, Sikariya More, Gaya, Bihar
            </p>
            <p className="mt-3 flex flex-col gap-1 text-sm text-white/70">
              <a href={telLink(CONFIG.phonePrimary)} className="flex items-center gap-2 hover:text-white"><Phone size={16} /> +91 {CONFIG.phonePrimary}</a>
              <a href={telLink(CONFIG.phoneSecondary)} className="flex items-center gap-2 hover:text-white"><Phone size={16} /> +91 {CONFIG.phoneSecondary}</a>
            </p>
          </div>

          <div>
            <h4 className="font-head text-sm font-bold uppercase tracking-widest text-white/50">Quick Links</h4>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              {NAV.map((n) => <li key={n.id}><button onClick={() => go(n.id)} className="hover:text-white">{t(n)}</button></li>)}
            </ul>
          </div>

          <div>
            <h4 className="font-head text-sm font-bold uppercase tracking-widest text-white/50">Services</h4>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              {SERVICES.slice(0, 6).map((s, i) => <li key={i}>{t(s).t}</li>)}
            </ul>
          </div>

          <div>
            <h4 className="font-head text-sm font-bold uppercase tracking-widest text-white/50">Legal</h4>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li><Link to="/privacy-policy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link></li>
              <li><Link to="/medical-disclaimer" className="hover:text-white" data-testid="footer-disclaimer">Medical Disclaimer</Link></li>
              <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms of Use</Link></li>
              <li><a href={CONFIG.mapsLink} target="_blank" rel="noopener noreferrer" className="hover:text-white">Google Maps</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 rounded-2xl bg-white/5 p-5 text-xs leading-relaxed text-white/60">
          <span className="font-bold text-white/80">Medical Disclaimer: </span>{t(DISCLAIMER)}
        </div>

        <div className="mt-8 border-t border-white/10 pt-6 text-center text-xs text-white/50">
          © {new Date().getFullYear()} Jan Seva Hospital, Gaya. All rights reserved. · “Your Health, Our Responsibility” · “आपकी सेहत, हमारी ज़िम्मेदारी”
        </div>
      </div>
    </footer>
  );
};
